import {
  LinkedinLogo, XLogo, Article, MediumLogo, InstagramLogo,
  TiktokLogo, YoutubeLogo, MastodonLogo, Butterfly, FacebookLogo,
} from "@phosphor-icons/react";

const SOCIALS = [
  { icon: LinkedinLogo, url: "https://www.linkedin.com/in/magnusloev/", name: "LinkedIn" },
  { icon: XLogo, url: "https://x.com/MagnusLSchmidt", name: "X" },
  { icon: Article, url: "https://magnuslvschmidt.substack.com/", name: "Substack" },
  { icon: MediumLogo, url: "https://medium.com/@MagnusSchmidt", name: "Medium" },
  { icon: InstagramLogo, url: "https://www.instagram.com/magnusloeve/", name: "Instagram" },
  { icon: TiktokLogo, url: "https://www.tiktok.com/@magnusloev", name: "TikTok" },
  { icon: YoutubeLogo, url: "https://www.youtube.com/@Magnusloevschmidt", name: "YouTube" },
  { icon: MastodonLogo, url: "https://mastodon.social/@magnusloev", name: "Mastodon" },
  { icon: Butterfly, url: "https://bsky.app/profile/magnusloev.bsky.social", name: "Bluesky" },
  { icon: FacebookLogo, url: "https://www.facebook.com/profile.php?id=61580638511779", name: "Facebook" },
];

export default function SocialLinks({ columns = "grid-cols-2" }) {
  return (
    <div className={`grid ${columns} gap-2`} data-testid="social-links">
      {SOCIALS.map((s) => (
        <a
          key={s.name}
          href={s.url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={s.name}
          className="group flex items-center gap-3 rounded-xl border border-border bg-card px-4 py-3 transition-all hover:border-foreground hover:-translate-y-0.5"
        >
          <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-secondary text-foreground transition-colors group-hover:bg-foreground group-hover:text-background">
            <s.icon size={17} weight="fill" />
          </span>
          <span className="text-sm font-medium">{s.name}</span>
        </a>
      ))}
    </div>
  );
}
